import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import { EditarComponent }  from "./components/personas/personas/editar/editar/editar.component"
import { AdminGuard } from './shared/guard/admin.guard';
import { ResponderEncuestaComponent } from './components/comercial/encuestas/responder-encuesta/responder-encuesta.component';
import { InvitacionComponent } from './components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/invitacion/invitacion.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/default',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginComponent
  },
  // Ruta pública — sin autenticación
  {
    path: 'encuestas/responder/:nit/:id/:nitEmpresa',
    component: ResponderEncuestaComponent
  },
  {
    path: 'Asistencia/:id/:tenantId',
    component: InvitacionComponent
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [AdminGuard],
    children: content
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AdminGuard],
    children: full
  },
  {
    path: '**',
    redirectTo: ''
  },
  { path: 'persona/editar/:id',
    component: EditarComponent 
  }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
})],
],
  exports: [RouterModule]
})
export class AppRoutingModule { }